export const defaultMaxResults = 25;

export enum filterId {
  query = 'query',
  subscriberGroup = 'subscriberGroup'
}

export const mobileWidth = 766;
